import { resolveReleaseRouteRedirect } from "./release-route-redirect-map.mjs";

// These are approved URL dispositions, not guesses based on titles/slugs.
// Keep the serving 301s intact; sitemap source readers resolve the destination
// through the ordinary publication/identity checks before emitting anything.
export const SITEMAP_LANDING_SOURCE_REDIRECTS = Object.freeze({
  "/ie/dublin-classic-wedding-car-hire": "/ie/wedding-car-hire-dublin",
  "/se/stockholm-classic-wedding-car-hire": "/se/brollopskorning-stockholm",
  "/be/location-voiture-classique-sans-chauffeur-liege": "/be/fr-BE/location-voiture-classique-sans-chauffeur-liege",
  "/be/fr/rejoignez-nous": "/be/rejoignez-nous",
  "/bg/американска-кола-под-наем": "/bg/класическа-кола-под-наем",
  "/bg/шофирайте-мечтаната-кола": "/bg/класическа-кола-под-наем",
});

export function sitemapCanonicalLandingPath(pathname) {
  const decoded = decodeURI(pathname);
  return SITEMAP_LANDING_SOURCE_REDIRECTS[decoded] ||
    resolveReleaseRouteRedirect(decoded) || pathname;
}
